import { ThemeProvider } from "@emotion/react";
import React from "react";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Project from "./pages/Project";
import Skill from "./pages/Skill";
import { theme } from "./theme";
function App() {
  return (
    <ThemeProvider theme={theme}>
      <Home />
      <Skill />
      <Project />
      <Blog />
      <Contact />
    </ThemeProvider>
  );
}

export default App;
